<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
   
        <b-button block v-b-toggle.privacy-section-4
        class="text-left fw-500 d-flex align-items-center justify-content-between">
            <div>
                <span class="box-numbering">04</span>
                <span>How We Share Your Information</span>    
            </div>
            <span 
                class="toggle-icon" 
                :class="{ active: isOpen }"
            >
                <span class="plus">+</span>
                <span class="cross">×</span>
            </span> 
        </b-button>

      </b-card-header>
      <b-collapse
        id="privacy-section-4"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            How We Share Your Information We do not sell or rent your personal
            information to third parties. However, we may share your information
            with:
          </p>
          <p class="text-justify">
            Service Providers: Third-party companies that assist us in providing
            services, including payment processing, customer support, and data
            storage.
          </p>
          <p class="text-justify">
            Legal Authorities: To comply with applicable laws, regulations, or
            legal processes, or to respond to government requests.
          </p>
          <p class="text-justify">
            Business Transfers: In connection with a merger, acquisition, or
            sale of all or a portion of our assets.
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "section-4",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
